'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Column = styled__default.default.div `
  display: flex;
  flex-direction: column;
  justify-items: ${({ justifyItems = 'flex-start' }) => justifyItems};
  align-content: ${({ alignContent = 'flex-start' }) => alignContent};
  && > * {
    margin-bottom: ${({ space, theme }) => theme.space.component.y[space]};
  }
  && > *:last-child {
    margin-bottom: 0;
  }
`;
Column.displayName = 'Flex.Column';

exports.Column = Column;
//# sourceMappingURL=Column.js.map
